import StockClotureJourController from './stock.cloture.jour.controller';

export default {
    template: require('./stock.cloture.jour.html'),
    controller: StockClotureJourController
};
